import { render } from "./AgilityRatingPill.vue?vue&type=template&id=58166176&ts=true"
import script from "./AgilityRatingPill.vue?vue&type=script&lang=ts"
export * from "./AgilityRatingPill.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__